<template>
  <div class="about">
    <b-container>
      <b-row class="align-items-center">
        <b-col cols="12" md="6">
          <h2 class="about__title text-center text-sm-left">Our Story</h2>
          <p class="about__description">
            Next Gen Garage Services began as a small, family-owned business
            with a simple mission: provide honest, reliable garage door service
            to our neighbors in Essex County.
          </p>
          <p class="about__description">
            What started as a one-man operation has grown into New Jersey's most
            trusted garage door service company, but we've never forgotten our
            roots. Today, our team of certified technicians serves hundreds of
            families and businesses across the region, always with the same
            commitment to quality and customer care that built our reputation.
          </p>
          <p class="about__description">
            We believe that every customer deserves prompt, professional service
            at a fair price. That's why we offer same-day service and 24/7
            emergency response – because we know garage door problems don't wait
            for convenient times.
          </p>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-4 mt-md-0 d-flex justify-content-center"
        >
          <img
            src="../assets/imgs/team-photo.png"
            alt="Our Team"
            class="about__image img-fluid"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "AboutSection",
};
</script>

<style lang="scss" scoped>
.about {
  padding: 70px 0;
  background: #ffffff;

  &__title {
    font-size: 36px;
    font-weight: 700;
    color: #1d1729;
    margin-bottom: 20px;
  }

  &__description {
    font-size: 16px;
    line-height: 28px;
    color: #4a4a4a;
    margin-bottom: 15px;
  }

  &__image {
    border-radius: 20px;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 767.98px) {
    padding: 30px 0;

    &__title {
      font-size: 26px;
    }

    &__description {
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
